import React, { useState } from "react";
// import { UseAdmin } from "../hooks/index";
import { notification, Row, Modal } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import downloadPdf from "../../../utils/DownloadPDF";

export const ModalSelectEdivence = ({
  modalIsOpen,
  setModalIsOpen,
  setFileSelected,
  fileSelected,
  values,
  isEdit,
}) => {
  // const { brandfiMarcaId, branchFiSucursalId, branchFiPaisId } = UseAdmin();
  const [lastFileName, setLastFileName] = useState(null);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    // Validar el tipo de archivo
    if (!file.type.startsWith("image/jpeg") && values.type !== 2) {
      openNotificationWithIcon(
        "warning",
        "Por favor selecciona un archivo JPG o cambia el tipo de evidencia."
      );
      event.target.value = "";
      return;
    }

    if (values.type !== 1 && file.type !== "application/pdf") {
      openNotificationWithIcon(
        "warning",
        "Por favor selecciona un archivo PDF o cambia el tipo de evidencia."
      );
      event.target.value = "";
      return;
    }

    // Validar el tamaño del archivo (menor a 1 MB)
    if (file.size > 1024 * 1024) {
      openNotificationWithIcon("warning", "La imagen seleccionada debe tener menos de 1 MB.");
      event.target.value = "";
      return;
    }

    // Validar si el archivo tiene el mismo nombre que el previamente seleccionado
    if (file.name === lastFileName) {
      openNotificationWithIcon(
        "warning",
        `Ya has seleccionado este archivo anteriormente. Por favor, elige un archivo diferente.`
      );
      event.target.value = ""; // Restablecer el valor del input
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;

      let base64Data = "";
      if (file.type === "image/jpeg") {
        // Eliminar encabezado de imágenes JPG
        base64Data = base64String.replace(/^data:image\/jpeg;base64,/, "");
      } else if (file.type === "application/pdf") {
        // Eliminar encabezado de archivos PDF
        base64Data = base64String.replace(/^data:application\/pdf;base64,/, "");
      } else {
        console.error("Formato de archivo no soportado");
        return;
      }

      // Actualiza el estado o procesa los datos como sea necesario
      setFileSelected({
        base64Data,
        previewUrl: base64String,
        name: file.name,
      });
      setLastFileName(file.name);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
    event.target.value = ""; // Restablecer el valor del input para permitir seleccionar el mismo archivo nuevamente
  };

  const fetchHandleUpdateCancel = () => {
    // setFileSelected({
    //   base64Data: null,
    //   previewUrl: null,
    //   name: "",
    // });
    setModalIsOpen(false);
    setLastFileName(null);
  };

  const handleSave = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      {contextHolder}
      <Modal open={modalIsOpen} onCancel={fetchHandleUpdateCancel} footer={null}>
        <div className="conteiner-modal-body-evidencias">
          <Row justify="center">
            <div className="mb-2">
              <div className="mb-2">
                {`El archivo seleccionado debe estar en formato ${
                  values.type === 1 ? "JPG" : "PDF"
                } y tener un tamaño inferior a 1 MB`}
              </div>
            </div>
            <label
              htmlFor="image-input"
              style={{
                background: "#41b6e6", // Color de fondo
                color: "#fff", // Color del texto
                padding: "10px 15px", // Espaciado interno
                borderRadius: "5px", // Borde redondeado
                cursor: "pointer", // Cursor al pasar sobre el botón
              }}
            >
              Seleccionar evidencia
            </label>
            <input
              type="file"
              id="image-input" // Añade un ID al input
              onChange={handleFileChange}
              accept=".jpg, .pdf"
              capture="user"
              style={{
                display: "none", // Oculta el input
              }}
            />
          </Row>

          {fileSelected.previewUrl && values.type === 1 ? (
            <>
              <div>
                <img
                  src={fileSelected.previewUrl}
                  alt="Selecionar"
                  className="image-pick-recolecion"
                />
              </div>
              <div>
                <button className={`${"file-button-cancel"}`} onClick={fetchHandleUpdateCancel}>
                  Cancelar
                </button>

                <button className={`${"file-button-save"}`} onClick={handleSave}>
                  {"Guardar"}
                </button>
              </div>
            </>
          ) : fileSelected.previewUrl && values.type === 2 ? (
            <>
              <div>
                <FilePdfOutlined
                  style={{
                    fontSize: "20px",
                    color: "#1890ff",
                    cursor: "pointer",
                  }}
                  onClick={() => downloadPdf(fileSelected.name, fileSelected.previewUrl)}
                />
                <span>{fileSelected.name}</span>
              </div>
              <div>
                <button className={`${"file-button-cancel"}`} onClick={fetchHandleUpdateCancel}>
                  Cancelar
                </button>

                <button className={`${"file-button-save"}`} onClick={handleSave}>
                  {"Guardar"}
                </button>
              </div>
            </>
          ) : null}
        </div>
      </Modal>
    </>
  );
};
